/**
 * paradisesociety Custom Cursor
 *
 * Rendered size is controlled ONLY by the cursor bitmap dimensions
 * (Shopify CDN width/height on the image URL). CSS `cursor: url()` has
 * no width/height/transform — config.size alone does nothing unless the
 * URL is resized to match.
 */
(function () {
  'use strict';

  var STYLE_ID = 'fkx-custom-cursor-styles';
  var ROOT_CLASS = 'fkx-custom-cursor-active';
  var VAR_NAME = '--fkx-cursor-image';

  function config() {
    return window.fkxCursorConfig || {};
  }

  /**
   * Force CDN bitmap to exact render size. Source asset is 32×32; requesting
   * a larger width returns the same 32×32 file. Smaller width/height downscales.
   */
  function sizedCursorUrl(rawUrl, size) {
    if (!rawUrl || !size) return rawUrl;
    try {
      var absolute = rawUrl.indexOf('//') === 0 ? 'https:' + rawUrl : rawUrl;
      var u = new URL(absolute, window.location.href);
      var px = String(Math.max(1, Math.round(size)));
      u.searchParams.set('width', px);
      u.searchParams.set('height', px);
      u.searchParams.set('crop', 'center');
      if (rawUrl.indexOf('//') === 0) {
        return '//' + u.host + u.pathname + u.search;
      }
      return u.href;
    } catch (e) {
      return rawUrl;
    }
  }

  function buildCss(url, hx, hy) {
    var hotspotX = typeof hx === 'number' && !isNaN(hx) ? Math.round(hx) : 0;
    var hotspotY = typeof hy === 'number' && !isNaN(hy) ? Math.round(hy) : 0;
    var value = 'url("' + url + '") ' + hotspotX + ' ' + hotspotY + ', auto';
    return (
      ':root {\n  ' +
      VAR_NAME +
      ': ' +
      value +
      ';\n}\n' +
      '@media (hover: hover) and (pointer: fine) {\n' +
      '  html.' +
      ROOT_CLASS +
      ',\n' +
      '  html.' +
      ROOT_CLASS +
      ' *,\n' +
      '  html.' +
      ROOT_CLASS +
      ' *::before,\n' +
      '  html.' +
      ROOT_CLASS +
      ' *::after {\n' +
      '    cursor: var(' +
      VAR_NAME +
      ') !important;\n' +
      '  }\n' +
      '}\n'
    );
  }

  // classList.add/remove zapisuje atrybut class nawet bez zmiany — to budziło obserwatora niżej, który znów
  // wołał applyCursor: pętla co klatkę i przeliczanie stylów całej strony. Ruszamy klasę tylko, gdy trzeba.
  function setRootClass(on) {
    var list = document.documentElement.classList;
    if (list.contains(ROOT_CLASS) !== on) list.toggle(ROOT_CLASS, on);
  }

  function removeCursor() {
    setRootClass(false);
    var el = document.getElementById(STYLE_ID);
    if (el) el.remove();
  }

  function applyCursor() {
    var cfg = config();
    if (!cfg.enabled || !cfg.url) {
      removeCursor();
      return;
    }

    // Render size = bitmap px. Default 16 = 50% of the 32×32 source asset.
    var size = typeof cfg.size === 'number' && cfg.size > 0 ? cfg.size : 16;
    var url = sizedCursorUrl(cfg.url, size);
    var hx = typeof cfg.hotspotX === 'number' ? cfg.hotspotX : Math.round(size / 2);
    var hy = typeof cfg.hotspotY === 'number' ? cfg.hotspotY : Math.round(size / 2);
    var css = buildCss(url, hx, hy);

    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }
    if (style.textContent !== css) {
      style.textContent = css;
    }
    setRootClass(true);
  }

  function bindShopifyEvents() {
    var events = [
      'shopify:section:load',
      'shopify:section:unload',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:block:select',
      'shopify:block:deselect',
      'shopify:inspector:activate',
      'shopify:inspector:deactivate',
    ];
    events.forEach(function (name) {
      document.addEventListener(name, applyCursor);
    });
  }

  // Pilnuje tylko tego, co może zdjąć kursor: klasy na <html> i <style> w <head>
  // (obserwowanie całej strony kosztowało przy każdej animacji)
  function startObserver() {
    if (!window.MutationObserver) return;
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyCursor();
      });
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
    observer.observe(document.head, { childList: true });
  }

  function init() {
    applyCursor();
    bindShopifyEvents();
    startObserver();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) applyCursor();
    });
    window.addEventListener('pageshow', applyCursor);
    window.addEventListener('resize', applyCursor);
    window.addEventListener('orientationchange', applyCursor);
    document.addEventListener('cart:refresh', applyCursor);
    document.addEventListener('fkx:dom-updated', applyCursor);
  }

  window.fkxCursorRefresh = applyCursor;

  // Telefony i tablety nie mają kursora (CSS i tak działa tylko dla myszy) — nic nie uruchamiamy
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
